const state = {
  lists: [],
  currentListId: null
}

const mutations = {
  'SET_CURRENT_LIST' (state, listId) {
    state.currentListId = listId
  },
  'ADD_LIST' (state, list) {
    state.lists.push(list)
  },
  'TOGGLE_PRODUCT' (state, productId) {
    const list = state.lists.find(list => list.id === state.currentListId)
    const item = list.items.find(item => item.id === productId)
    if (item === undefined) {
      list.items.push({
        id: productId,
        collected: false
      })
    } else {
      const index = list.items.indexOf(item)
      if (index > -1) list.items.splice(index, 1)
    }
  },
  'TOGGLE_ITEM_COLLECTED' (state, toggledItem) {
    // Kan vast efficienter...
    const currentList = state.lists.find(list => list.id === state.currentListId)
    const item = currentList.items.find(item => item.id === toggledItem.id)
    item.collected = !item.collected
  },
  'UPDATE_LIST' (state, newListOrder) {
    const currentList = state.lists.find(storeList => storeList.id === state.currentListId)
    currentList.items = newListOrder
  },
  'REMOVE_LIST' (state, id) {
    state.lists = state.lists.filter(item => { return item.id !== id })
  },
  'SET_COLLECTED_ITEMS_TO_SUGGESTIONS' (state, currentList) {
    const collectedListItems = currentList.items.filter(item => item.collected)
    // add suggestions array if didn't yet exist
    collectedListItems.forEach(item => {
      // check if suggested item already exist
      const suggestedItem = currentList.suggestions.find(suggestedItem => suggestedItem.id === item.id)
      if (suggestedItem) {
        const lastAddedTimestamp = suggestedItem.collected[suggestedItem.collected.length - 1]
        const currentTimestamp = Date.now()
        // 1000ms * 60 = 1m * 60 = 1h
        const buffer = 1000 * 60 * 60 * 2
        if ((currentTimestamp - lastAddedTimestamp) > buffer) suggestedItem.collected.push(currentTimestamp)
      } else {
        // suggested item does not yet exist, so add it (with timestamp)
        currentList.suggestions.push({
          id: item.id,
          collected: [Date.now()]
        })
      }
    })
    currentList.items = currentList.items.filter(item => !item.collected)
  }
}

const actions = {
  setCurrentList: ({commit}, list) => {
    commit('SET_CURRENT_LIST', list)
  },
  toggleProductToList: ({commit}, productId) => {
    commit('TOGGLE_PRODUCT', productId)
  },
  setCollectedItemsToSuggestion: ({commit, getters}) => {
    commit('SET_COLLECTED_ITEMS_TO_SUGGESTIONS', getters.getCurrentList)
  }
}

const getters = {
  getLists: state => state.lists,
  getCurrentList: state => {
    const lists = state.lists
    const id = state.currentListId
    const currentList = lists.find(list => list.id === id)
    return currentList || null
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/listsStore.js